import { Component, Input, output } from  '@angular/core'; 
import { SpacingInput } from  './spacingInputComponent/spacing-component';
import { IfourInputs } from '../../cockpitDesigner.models';
import { getRandomValues } from 'node:crypto';


@Component({
  selector: 'app-four-input',
  styleUrl: 'four-inputs.component.css',
  templateUrl:'four-inputs.component.html',
  imports: [SpacingInput]
})

export class FourInputs {
  @Input()  left: number = 0;
  @Input()  top: number = 0;
  @Input()  right: number = 0;
  @Input()  bottom: number = 0;

  @Input()  borderRadiusTopLeft: number = 0;
  @Input()  borderRadiusTopRight: number = 0;
  @Input()  borderRadiusBottomRight: number = 0;
  @Input()  borderRadiusBottomLeft: number = 0;


  valueChange = output<IfourInputs>()

  handleValueChange(event:number, location: keyof IfourInputs) {
    console.log('this is the new number', event)
    const values= {
      left: this.left,
      top: this.top,
      right: this.right,
      bottom: this.bottom,
    }

    console.log('changing values',values)
    this.valueChange.emit({
      ...values,
      [location]: event
    })
    
  }
}